'use client';
import { useSwitchChain } from '@shared/helpers/web3/chain';
import { useLogin } from '@shared/hooks/useLogin';

import { Button } from '@ui/uikit/components/common/Button';

type ConnectWalletButtonProps = {
  onConnectSwitchToChainId?: number;
  isDisabled?: boolean;
};

export const ConnectWalletButton = ({
  onConnectSwitchToChainId,
  isDisabled,
}: ConnectWalletButtonProps) => {
  const { login, isLogging } = useLogin();
  const { switchChain, isSwitching } = useSwitchChain();

  const onClickConnect = async () => {
    await login({
      signMessage: 'Confirm authorization in Magic Store with your wallet',
    });

    if (onConnectSwitchToChainId) {
      void switchChain({ destChainId: onConnectSwitchToChainId });
    }
  };

  return (
    <Button
      disabled={isDisabled || isLogging || isSwitching}
      onClick={onClickConnect}
      type="button"
      size="large"
      width="100%"
    >
      Connect Wallet
    </Button>
  );
};
